export class TournamentWSClientError extends Error {
  constructor(message: string, public readonly code?: number) {
    super(message);
    this.name = "TournamentWSClientError";
  }
}

export class ConnectionError extends TournamentWSClientError {
  constructor(message: string) {
    super(message);
    this.name = "ConnectionError";
  }
}

export class AuthenticationError extends TournamentWSClientError {
  constructor(message: string = "Authentication failed") {
    super(message, 401);
    this.name = "AuthenticationError";
  }
}

export class RequestError extends TournamentWSClientError {
  constructor(message: string, public readonly statusCode: number) {
    super(message, statusCode);
    this.name = "RequestError";
  }
}

export class TimeoutError extends TournamentWSClientError {
  constructor(message: string = "Request timed out") {
    super(message, 408);
    this.name = "TimeoutError";
  }
}

export class ValidationError extends TournamentWSClientError {
  constructor(message: string) {
    super(message, 400);
    this.name = "ValidationError";
  }
}
